var _style, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _path6, _rect4, _rect5, _rect6, _circle, _circle2, _path7, _rect7, _rect8, _rect9, _path8, _path9, _polygon, _path10, _polygon2, _path11, _polygon3, _polygon4, _path12, _polygon5, _path13, _rect10, _circle3, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "messageIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 734.73628,
    height: 779.78485,
    viewBox: "0 0 734.73628 779.78485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0{fill:#D3D3D3;}\n        .st3{fill:#FF0000;}\n        .st4{fill:#000000;}\n        .st5{fill:#ffffff;}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M967.36814,233.05483h-3.99878V123.50949a63.40184,63.40184,0,0,0-63.40179-63.40191H667.88084a63.40185,63.40185,0,0,0-63.402,63.40172V724.48371a63.40186,63.40186,0,0,0,63.40179,63.40191H899.96726a63.40186,63.40186,0,0,0,63.402-63.40167V311.03107h3.99884Z",
    transform: "translate(-232.63186 -60.10758)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M902.52561,76.60256h-30.295a22.49484,22.49484,0,0,1-20.82715,30.99052H718.444a22.4948,22.4948,0,0,1-20.82715-30.99056H669.32127a47.34781,47.34781,0,0,0-47.34784,47.34774V724.04285a47.34781,47.34781,0,0,0,47.34777,47.34784H902.52561a47.3478,47.3478,0,0,0,47.34784-47.34778h0V123.9503A47.34776,47.34776,0,0,0,902.52561,76.60256Z",
    transform: "translate(-232.63186 -60.10758)",
    className: "st5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M798.1627,728.88642a89.85864,89.85864,0,1,1,66.44775-29.41327l18.76538,21.03576-9.36432,3.97211c-14.48639,6.14472-28.66235.16559-36.619-4.60626A89.97151,89.97151,0,0,1,798.1627,728.88642Zm0-164.94757a75.18442,75.18442,0,1,0,36.14392,141.12371l4.00873-2.20269,3.72723,2.65216A39.4221,39.4221,0,0,0,856.267,712.02l-11.80835-13.23675,5.17614-4.8642a74.47632,74.47632,0,0,0,23.71234-54.79572A75.26973,75.26973,0,0,0,798.1627,563.93885Z",
    transform: "translate(-232.63186 -60.10758)",
    className: "st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M880.63645,639.12317a82.44129,82.44129,0,1,0-42.8197,72.32837c5.70105,4.05634,19.609,12.147,33.34833,6.31909L854.6265,699.23126A82.23982,82.23982,0,0,0,880.63645,639.12317Z",
    transform: "translate(-232.63186 -60.10758)",
    className: "st5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 523.05395,
    y: 562.15271,
    width: 58.93216,
    height: 5.47272,
    className: "st3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 523.05395,
    y: 581.08453,
    width: 102.71378,
    height: 5.47272,
    className: "st0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 523.05395,
    y: 600.0163,
    width: 102.61319,
    height: 5.47272,
    className: "st0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M798.1627,329.88639a89.85859,89.85859,0,1,1,66.44775-29.41324l18.76538,21.03579-9.36432,3.97211c-14.48639,6.14472-28.66235.16556-36.619-4.60629A89.9719,89.9719,0,0,1,798.1627,329.88639Zm0-164.94756a75.18443,75.18443,0,1,0,36.14392,141.12373l4.00873-2.20266,3.72723,2.65216A39.4221,39.4221,0,0,0,856.267,313.02l-11.80835-13.23675,5.17614-4.86417a74.4765,74.4765,0,0,0,23.71234-54.79578,75.26971,75.26971,0,0,0-75.18444-75.18444Z",
    transform: "translate(-232.63186 -60.10758)",
    className: "st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M880.63645,240.1232a82.44137,82.44137,0,1,0-42.8197,72.32837c5.70105,4.05631,19.609,12.14707,33.34833,6.31906l-16.53858-18.5394A82.23979,82.23979,0,0,0,880.63645,240.1232Z",
    transform: "translate(-232.63186 -60.10758)",
    className: "st5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 523.05395,
    y: 163.15269,
    width: 58.93216,
    height: 5.4727,
    className: "st3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 523.05395,
    y: 182.0845,
    width: 102.71378,
    height: 5.4727,
    className: "st0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 523.05395,
    y: 201.01633,
    width: 102.61319,
    height: 5.4727,
    className: "st0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 679.76773,
    cy: 264.44629,
    r: 13,
    className: "st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 679.76773,
    cy: 663.44629,
    r: 13,
    className: "st0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M625.30534,536.11564c-9.5135,5.70547-26.46313,12.85456-43.78391,5.50757l-11.19653-4.74934,22.437-25.15166a107.15648,107.15648,0,1,1,32.5434,24.39343Z",
    transform: "translate(-232.63186 -60.10758)",
    className: "st3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M762.59857,439.06616a98.6152,98.6152,0,0,0-89.895-98.22284c2.87241-.25161,5.7779-.38776,8.71557-.38776a98.6106,98.6106,0,0,1,0,197.22116c-2.93324,0-5.83375-.13791-8.7018-.389A98.61525,98.61525,0,0,0,762.59857,439.06616Z",
    transform: "translate(-232.63186 -60.10758)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 382.95641,
    y: 359.29429,
    width: 70.46282,
    height: 6.54348,
    className: "st5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 382.95641,
    y: 381.93032,
    width: 122.81076,
    height: 6.54348,
    className: "st5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 382.95641,
    y: 404.56632,
    width: 122.69052,
    height: 6.54348,
    className: "st5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233.63186,839.89242h381a1,1,0,0,0,0-2h-381a1,1,0,0,0,0,2Z",
    transform: "translate(-232.63186 -60.10758)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M416.41683,409.62739l1.50587-7.52935s22.14933-7.52935,24.62749,7.52935Z",
    transform: "translate(-232.63186 -60.10758)",
    className: "st0"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "226.294 764.098 240.815 764.097 247.723 708.088 226.291 708.089 226.294 764.098",
    fill: "#9f616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M455.22155,819.46461l28.59689-.00116h.00116a18.22516,18.22516,0,0,1,18.22418,18.22389v.59222l-46.82136.00173Z",
    transform: "translate(-232.63186 -60.10758)",
    className: "st4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "156.294 764.098 170.815 764.097 177.723 708.088 156.291 708.089 156.294 764.098",
    fill: "#9f616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M385.22155,819.46461l28.59689-.00116h.00116a18.22516,18.22516,0,0,1,18.22418,18.22389v.59222l-46.82136.00173Z",
    transform: "translate(-232.63186 -60.10758)",
    className: "st4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "162.703 381.143 146.138 379.637 135.597 429.331 137.103 474.507 153.668 534.742 176.256 521.189 164.209 459.448 162.703 381.143",
    className: "st4"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "152.218 529.471 155.926 561.094 159.409 634.882 151.409 744.84 180.02 743.305 194.044 628.859 202.608 576.153 214.655 636.388 222.185 749.328 251.549 746.975 251.549 635.991 252.302 555.071 241.761 523.448 152.218 529.471",
    className: "st4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M446.53422,411.13325s-10.54108-15.05869-30.11739-4.5176l-9.03522,12.04695-28.61152,21.08218,6.02348,70.77586L377.26422,599.367,484.181,597.86108l-18.07043-88.8463V414.145Z",
    transform: "translate(-232.63186 -60.10758)",
    className: "st4"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "155.926 404.632 147.292 507.871 158.185 451.919 155.926 404.632",
    opacity: 0.25
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M568.28389,551.29919a11.10634,11.10634,0,0,1-14.55276-8.84574l-24.63864-6.08917.04853-15.87535,34.67376,9.08778a11.16654,11.16654,0,0,1,4.46911,21.72248Z",
    transform: "translate(-232.63186 -60.10758)",
    fill: "#9f616a"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 533.59292,
    y: 527.80238,
    width: 24.09391,
    height: 10.54109,
    transform: "translate(-305.95057 918.81273) rotate(-80.09845)",
    className: "st0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.77597,
    cy: 363.50007,
    r: 30.23918,
    transform: "translate(-354.32115 190.58405) rotate(-28.66319)",
    fill: "#9f616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M432.03476,390.17478a30.67347,30.67347,0,0,1-20.06795-57.65152,35.86829,35.86829,0,0,1,16.936-3.03923c9.04372.47548,17.83367,3.818,26.88653,3.57174l1.31214,2.10915,4.94513-1.1993,1.05965,3.92608,1.30256-.04509c2.33327,4.336-1.42084,10.54381-6.34451,10.49127-1.94936-.0208-3.79255-.83293-5.69875-1.24139s-4.151-.30666-5.46543,1.133c-1.70825,1.871-.96462,4.79061-.60844,7.299s-.53342,5.887-3.06559,5.96885c-1.2935.04183-2.52372-.88578-3.79472-.64189-1.4804.28406-2.22892,2.07169-2.01278,3.56352a14.18014,14.18014,0,0,0,1.77124,4.135c3.67068,7.32734.57119,17.29465-6.60746,21.24822",
    transform: "translate(-232.63186 -60.10758)",
    className: "st4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M458.92308,419.96341l7.18745-5.81842s14.50589-1.00847,14.24393,14.36948l23.21047,72.6043,44.52756,15.77365-6,31-63-24-32-53.03959Z",
    transform: "translate(-232.63186 -60.10758)",
    className: "st4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.dccf1a721ef554cddb257377ece70c3e.svg";
export { ForwardRef as ReactComponent };